import PortfolioContainer from "../containers/PortfolioContainer"

export default () => {
    return (
        <PortfolioContainer />
    )
}
